import axiosInstance from './axios/axiosConfig'
import { endpoints } from './axios/endpoints'

// Each caller shows the answer itself (Bulk Send's list and toast, the
// pipeline delete dialog), so the shared success and error toasts are off.
// A 401 still signs the user out through the axios interceptor.
const quiet = { silentToast: true, silentErrorToast: true }

/**
 * The scheduled bulk sends of an event type, and cancelling one. Bulk Send's
 * "Scheduled sends" section and the pipeline delete check share these two
 * calls; read their answers with helpers/scheduledSends.
 */
const ScheduledSendService = {
    /** The event type's sends still to go out (GET /comms/v2/get_schedule_comms). */
    list: (eventType) =>
        axiosInstance.get(endpoints.scheduledSends, {
            params: { event_type: eventType },
            ...quiet,
        }),

    /** Stop one scheduled send (POST /comms/v2/disable_scheduled_comms, body from cancelPayload). */
    cancel: (payload) =>
        axiosInstance.post(endpoints.cancelScheduledSend, payload, quiet),
}

export default ScheduledSendService
